var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbnailEdit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 15,
  viewBox: "0 0 16 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.5 8 16 9.5 10.5 15H9v-1.5zm-3.495-8A2.996 2.996 0 0 1 14 2.998V7.17l-2 2V2.998A.996.996 0 0 0 11.005 2h-8.01C2.455 2 2 2.447 2 2.998v7.004c0 .552.446.998.995.998h7.176l-2 2H2.995A2.996 2.996 0 0 1 0 10.002V2.998A3.003 3.003 0 0 1 2.995 0ZM5 5.5l4 3L8 7l1-1 2 2.096V10H3V8.096zM9 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
})));
export default SvgThumbnailEdit;